import { render, staticRenderFns } from "./ForgotPw_post_done.vue?vue&type=template&id=8683b6e2&scoped=true&"
import script from "./ForgotPw_post_done.vue?vue&type=script&lang=js&"
export * from "./ForgotPw_post_done.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPw_post_done.vue?vue&type=style&index=0&id=8683b6e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8683b6e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
